import React, { useEffect, useState } from 'react'
import { Box, Button } from '@mui/material'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import { Item } from '../../../common/snippets'
import DropDownOA from '../../../common/dropDownOA'
import { connect } from 'react-redux'
import { updateAlertError, updateModal } from '../../../../store/common/common_action';
import { focusElemnt, isEmpty, navigation3 } from '../../../common/helper'
import UserRollRightsTable from './UserRollRightsTable'
import { getUserRollRightTableData } from "../../../../store/branchAndUserMaster/BUMAction"
import { useTranslation } from '../../../../i18n/I18nProvider'

const UserRollRights = (props) => {
    const { translations } = useTranslation()
    const bum = translations?.branchAndUserMaster || {}
    const cs = translations?.common || {}
    const { data, updateAlertError, getUserRollRightTableData,loginData } = props
    const { common, branchAndUserMasterReducer } = data
    const { userRollRightTableData } = branchAndUserMasterReducer
    const [showTable, setShowTable] = useState(false)
    const [status, setStatus] = useState({ name: bum.active || "Active", id: 1 })
    const [catagoryData, setCatagoryData] = useState([])
    const [selCatagoryData, setSelCatagoryData] = useState("")
    const statusOpt = [{ name: bum.showAll || "Show All", id: -1 }, { name: bum.active || "Active", id: 1 }, { name: bum.inActive || "InActive", id: 0 }]
    useEffect(() => {
        if (translations) {
            const currentStatus = statusOpt.find(item => item.id === status?.id);
            if (currentStatus) setStatus(currentStatus);
            
            if (selCatagoryData?.RoleID === 0) {
                setSelCatagoryData({ RoleID: 0, RoleName: bum.all || "All" });
            }
        }
    }, [translations]);
    const [searchData, setSearchData] = useState({
        RoleName: "", Description: "", ModifiedByUserName: "", ModifiedByBranchName: "",
    })
    useEffect(() => {
        focusElemnt("URRCatagory")
    }, [])
    useEffect(() => {
        if (loginData?.intCompanyID !== 'undefined') {
            const body = {
                CompanyID: loginData?.intCompanyID,
                RoleID: 0,
                IsActive: 1
            }
            getUserRollRightTableData(body, cs.noData || 'No Data')
        }
    }, [loginData?.intCompanyID])
    useEffect(() => {
        if (userRollRightTableData?.Table?.length > 0) {
            if (selCatagoryData == "") {
                setSelCatagoryData({ RoleID: 0, RoleName: bum.all || "All" })
                setCatagoryData([{ RoleID: 0, RoleName: bum.all || "All" }, ...userRollRightTableData?.Table])
                setShowTable(true)
            }
        }
    }, [userRollRightTableData])

    const onLoad = () => {
        if (selCatagoryData !== "") {
            const body = {
                CompanyID: loginData?.intCompanyID,
                RoleID: selCatagoryData?.RoleID,
                IsActive: status?.id
            }
            getUserRollRightTableData(body, cs.noData || 'No Data')
            setShowTable(true)
            setSearchData({ RoleName: "", Description: "", ModifiedByUserName: "", ModifiedByBranchName: "", })
        } else {
            updateAlertError({ show: true, msg: bum.selectCatagoryName || "Select Catagory Name", nextId: "URRCatagory" })
        }
    }
    return (
        <>
            <Box sx={sx.reportFlex} className='itemButtons'>
                <Item sx={sx.itemsx} style={{ width: "250px" }}>
                    <DropDownOA
                        id={"URRCatagory"}
                        defaultvalue={selCatagoryData?.RoleName || ""}
                        data={catagoryData || []}
                        width="100%"
                        searchPlaceholder={bum.searchCategoryName || `Search Category Name`}
                        label={bum.categoryName || "Category Name"}
                        dataKey={`RoleName`}
                        idKey={`RoleID`}
                        nextId={"URRStatus"}
                        prevId={"URRSave"}
                        onSelect={(value) => setSelCatagoryData(value)}
                    />
                </Item>
                <Item sx={sx.itemsx} style={{ width: "250px" }}>
                    <DropDownOA
                        id={"URRStatus"}
                        defaultvalue={status?.name || ""}
                        data={statusOpt || []}
                        width="100%"
                        searchPlaceholder={bum.searchStatus || `Search Status`}
                        label={bum.status || cs.status || "Status"}
                        dataKey={`name`}
                        idKey={`id`}
                        nextId={"URRLoad"}
                        prevId={"URRCatagory"}
                        onSelect={(value) => setStatus(value)}
                    />
                </Item>
                <Item sx={sx.itemsx} className="disabled-wrapper" onKeyDown={(e) => navigation3(e, showTable ? "Contains-2" : "URRCatagory", "URRStatus", () => { })}>
                    <Button id="URRLoad" variant="contained" style={{ ...sx.fullHeight, ...sx.novp }} className="btn btn-primary"
                        onClick={onLoad}
                    >
                        {bum.load || "LOAD"}
                    </Button>
                </Item>
            </Box>
            <Box sx={sx.reportFlex}>
                {(showTable) && <UserRollRightsTable tableData={userRollRightTableData?.Table || []} onLoad={onLoad} searchData={searchData} setSearchData={setSearchData} loginData={loginData} />}
            </Box>
        </>
    )
}
const mapStateToProps = (data) => ({ data })

const mapDispatchToProps = {
    updateModal, updateAlertError, getUserRollRightTableData
}
export default connect(mapStateToProps, mapDispatchToProps)(UserRollRights)
